import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toothName } from '@/utils/dental';
import { deriveChart } from '@/utils/toothState';
import { Odontogram, ToothHistory } from '../chart/components';
import { MAP_ENTRIES } from './demoData';

const NONE: ReadonlySet<number> = new Set();

/** Tap a tooth, see its story. */
export function ToothMapShowcase() {
  const { t } = useTranslation('landing');
  const chart = useMemo(() => deriveChart(MAP_ENTRIES), []);
  const [tooth, setTooth] = useState(36);
  const history = MAP_ENTRIES.filter((e) => e.tooth === tooth);
  return (
    <div className="showcase__demo">
      <p className="showcase__hint">{t('showcase.map.hint')}</p>
      <Odontogram
        chart={chart}
        dentition="permanent"
        selected={tooth}
        recent={NONE}
        onSelect={setTooth}
      />
      <div className="showcase__history">
        <h4>
          {tooth} <span>{toothName(tooth)}</span>
        </h4>
        <ToothHistory entries={history} />
      </div>
    </div>
  );
}
